import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import "../styles/CTA.css";

function CTA({ title, description, imageSrc, primaryButtonText }) {
  const [formData, setFormData] = useState({
	firstName: "",
	lastName: "",
	phone: "",
	email: "",
	role: ""
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
	setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
	let errors = {};
	if (!formData.firstName) errors.firstName = "First name is required";
	if (!formData.lastName) errors.lastName = "Last name is required";
	if (!formData.phone) errors.phone = "Phone number is required";
	if (!formData.email) errors.email = "Email is required";
	if (!formData.role) errors.role = "Please select a role";
	setErrors(errors);
	return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
	e.preventDefault();

	if (!validateForm()) return;

	setIsSubmitting(true);
	setSuccessMessage("");

	try {
	  await addDoc(collection(db, "InterestList"), {
		firstName: formData.firstName,
		lastName: formData.lastName,
		phone: formData.phone,
		email: formData.email,
		role: formData.role,
		timestamp: new Date(),
		subscribe: "active"
	  });

	  console.log("✅ Submitted to Firestore:", formData);

	  setSuccessMessage("Thanks! You're on the list.");
	  setFormData({ firstName: "", lastName: "", phone: "", email: "", role: "" });
	  setErrors({});

	  setTimeout(() => {
		setSuccessMessage("");
		setIsSubmitting(false);
	  }, 3000);
	} catch (error) {
	  console.error("❌ Firestore error:", error);
	  setErrors({ form: "Something went wrong. Please try again." });
	  setIsSubmitting(false);
	}
  };

  return (
	<div className="cta">
	  <div className="cta-image-container">
		<div className="cta-image-border-wrapper">
		  <div className="cta-image-wrapper">
			<img src={imageSrc} alt={title} className="cta-image" />
		  </div>
		</div>
	  </div>
	  <div className="cta-content-border-wrapper">
		<div className="cta-content-wrapper">
		  <div className="cta-content">
			<h2 className="cta-title">{title}</h2>
			<p className="cta-description">{description}</p>
			<form className="cta-form" onSubmit={handleSubmit}>
			  <input
				type="text"
				name="firstName"
				placeholder="First Name"
				className={`cta-input ${errors.firstName ? "error" : ""}`}
				value={formData.firstName}
				onChange={handleChange}
			  />
			  {errors.firstName && <span className="error-message">{errors.firstName}</span>}

			  <input
				type="text"
				name="lastName"
				placeholder="Last Name"
				className={`cta-input ${errors.lastName ? "error" : ""}`}
				value={formData.lastName}
				onChange={handleChange}
			  />
			  {errors.lastName && <span className="error-message">{errors.lastName}</span>}

			  <input
				type="tel"
				name="phone"
				placeholder="Phone Number"
				className={`cta-input ${errors.phone ? "error" : ""}`}
				value={formData.phone}
				onChange={handleChange}
			  />
			  {errors.phone && <span className="error-message">{errors.phone}</span>}

			  <input
				type="email"
				name="email"
				placeholder="Email Address"
				className={`cta-input email ${errors.email ? "error" : ""}`}
				value={formData.email}
				onChange={handleChange}
			  />
			  {errors.email && <span className="error-message">{errors.email}</span>}

			  <div className="cta-select-wrapper">
				<select
				  name="role"
				  className={`cta-input ${errors.role ? "error" : ""}`}
				  value={formData.role}
				  onChange={handleChange}
				>
				  <option value="">Select Role</option>
				  <option value="coach">Coach</option>
				  <option value="family">Family</option>
				  <option value="individual">Individual</option>
				</select>
				{errors.role && <span className="error-message">{errors.role}</span>}
			  </div>

			  <div className="cta-submit-wrapper">
				{errors.form && <p className="error-message">{errors.form}</p>}
				{successMessage && <p className="success-message">{successMessage}</p>}

				<button type="submit" className="c-ripple primary-button" disabled={isSubmitting}>
				  {isSubmitting ? "Sending..." : primaryButtonText}
				</button>
			  </div>
			</form>
		  </div>
		</div>
	  </div>
	</div>
  );
}

export default CTA;